module.exports = __webpack_public_path__ + "8a0b932da863e8fd43b5103d79032482.png";